export default function HeroImageSection({
  formData,
  errors,
  refs,
  handleImageChange,
  handleInputChange,
}) {
  return (
    <div className="mb-6">
      <label className="block mb-2 font-semibold">Hero Image</label>

      <input
        ref={refs.HeroImg}
        type="file"
        accept="image/*"
        onChange={(e) => handleImageChange(e, null, "HeroImg")}
      />

      {errors.HeroImg && <p className="text-red-600">{errors.HeroImg}</p>}

      {formData.HeroImg && (
        <>
          <img
            src={URL.createObjectURL(formData.HeroImg)}
            className="w-56 h-56 mt-4 object-cover rounded"
          />

          <input
            ref={refs.HeroAltText}
            name="HeroAltText"
            value={formData.HeroAltText || ""}
            onChange={handleInputChange}
            placeholder="Hero image alt text"
            className="border p-2 w-full mt-2"
          />

          {errors.HeroAltText && (
            <p className="text-red-600">{errors.HeroAltText}</p>
          )}
        </>
      )}
    </div>
  );
}
